import { useCallback } from "react"
import { useMutation } from "react-relay"
import { Country } from "@/modules/patients/services/__generated__/PatientFragment.graphql"
import {
  Ch_deleteProgressNotesInput,
  chDeleteProgressNotesMutation,
} from "@/modules/patients/services/ch/__generated__/chDeleteProgressNotesMutation.graphql"
import { chDeleteProgressNotesMutation as chMutation } from "@/modules/patients/services/ch/chDeleteProgressNotesMutation"
import {
  De_deleteProgressNotesInput,
  deDeleteProgressNotesMutation,
} from "@/modules/patients/services/de/__generated__/deDeleteProgressNotesMutation.graphql"
import { deDeleteProgressNotesMutation as deMutation } from "@/modules/patients/services/de/deDeleteProgressNotesMutation"

export const useDeleteProgressNotes = (country: Country) => {
  const mutation = country === "CH" ? chMutation : deMutation

  const [commit] = useMutation<chDeleteProgressNotesMutation & deDeleteProgressNotesMutation>(mutation)

  return useCallback(
    (
      input: De_deleteProgressNotesInput & Ch_deleteProgressNotesInput,
      episodeOfCareIds: string[],
      onCompleted?: () => void,
    ) => {
      const connections: string[] = episodeOfCareIds
      commit({
        variables: {
          input,
          connections: connections,
        },
        onCompleted(response) {
          const data = response.deleteProgressNotes
          if (!data.errors?.length) {
            onCompleted?.()
          }
        },
      })
    },
    [commit],
  )
}
